import { type TenderOffer } from '../types'

export const mockTenderList: Array<TenderOffer> = [
  {
    id: '590f4b1b-fd5f-4f99-abf4-62abed771847',
    shipper: {
      companyName: 'Carrier Marketplace Shipper',
      email: 'johdoe@someemail.com',
      logoUrl:
        'https://rfpguide-staging.s3.amazonaws.com/media/logos/1043/croppedimage_07b75c54.jpeg',
      name: 'John Doe',
      phoneNumber: '202-555-0120',
    },
    carrier: {
      id: 5233,
      name: 'Robin Moody 0',
      email: 'fixture-email-123@carrier.com',
      entityType: 'carrier',
    },
    stops: [
      {
        city: 'Madison',
        state: 'WI',
        zipCode: '53701',
        address: '480 East Lincoln Highway',
        date: '2024-03-22',
        country: 'USA',
        stopIndex: 0,
        latitude: '43.0731',
        longitude: '-89.4012',
        stopType: 'pickup',
        appointment: {
          channel: 'shipperguide',
          mode: 'appt',
          loadingType: 'live',
          type: 'requested',
          status: 'confirmed',
          scheduledDate: { type: 'at', start: '2024-03-22', end: '2024-03-22' },
          scheduledTime: { type: 'at', start: '1400', end: '1400' },
        },
      },
      {
        city: 'Chicago',
        state: 'IL',
        zipCode: '60601',
        address: '1000 East Lincoln Highway',
        date: '2024-03-24',
        country: 'USA',
        stopIndex: 1,
        latitude: '41.8781',
        longitude: '-87.6298',
        stopType: 'delivery',
        appointment: {
          channel: 'shipperguide',
          mode: 'appt',
          loadingType: 'live',
          type: 'requested',
          status: 'pending',
          suggestedDate: { type: 'between', start: '2024-03-24', end: '2024-03-26' },
          suggestedTime: { type: 'after', start: '1530', end: '1530' },
        },
      },
    ],
    mileage: 448,
    flatRate: 1657.9,
    pricePerMile: 3.7,
    expirationDate: new Date(Date.now() + 4 * 60 * 60 * 1000),
    mode: 'FTL',
    equipmentType: 'DRV',
    equipmentTypeLabel: 'Dry Van',
    shipperGuideId: 'SGOIUEKBNDO2Y',
    notes:
      'APPT # 220837940. NO STEP DECKS OR CONESTOGAS. CANNOT GO INTERMODAL. PU# 220837940 PO # 38925773 Palletized',
    attachments: [
      {
        id: 1,
        fileName: 'document_name.pdf',
        url: 'https://example.com/attachments/document_name.pdf',
      },
      {
        id: 2,
        fileName: 'document_name.pdf',
        url: 'https://example.com/attachments/document_name_2.pdf',
      },
      {
        id: 3,
        fileName: 'document_name.pdf',
        url: 'https://example.com/attachments/document_name_3.pdf',
      },
    ],
    items: [
      {
        packageType: 'std_pallets',
        packageCount: 1,
        length: 48,
        width: 40,
        height: 96,
        weight: 40000,
        stackable: true,
        turnable: true,
        hazmat: true,
        commodity: 'General Freight',
        freightClass: '70',
      },
    ],
    measures: {
      totalWeight: 40000,
      volume: 0,
      density: 0,
      linearFeet: 0,
    },
    status: 'available',
    rateType: 'Spot',
    createdAt: new Date('2024-03-20T10:00:00Z'),
    shareDetails: true,
    powerOnly: false,
    rate: {
      uuid: '871d4ee4-5e30-479c-ad45-315cb6c93598',
    },
  },
  {
    id: '37e53280-b54a-4151-aa2d-c14b122686d6',
    shipper: {
      companyName: 'Carrier Marketplace Shipper',
      email: 'contact@acme.com',
      logoUrl:
        'https://rfpguide-staging.s3.amazonaws.com/media/logos/1043/croppedimage_07b75c54.jpeg',
    },
    carrier: {
      id: 5233,
      name: 'Robin Moody 0',
      email: 'fixture-email-123@carrier.com',
      entityType: 'carrier',
    },
    stops: [
      {
        city: 'Los Angeles',
        state: 'CA',
        zipCode: '90001',
        address: '123 Main Street',
        date: '2024-03-25',
        country: 'USA',
        stopIndex: 0,
        latitude: '34.0522',
        longitude: '-118.2437',
        stopType: 'pickup',
        appointment: {
          channel: 'shipperguide',
          mode: 'appt',
          loadingType: 'live',
          type: 'requested',
          status: 'confirmed',
          scheduledDate: { type: 'at', start: '2024-03-25', end: '2024-03-25' },
          scheduledTime: { type: 'at', start: '1000', end: '1000' },
        },
      },
      {
        city: 'San Francisco',
        state: 'CA',
        zipCode: '94102',
        address: '456 Market Street',
        date: '2024-03-26',
        country: 'USA',
        stopIndex: 1,
        latitude: '37.7749',
        longitude: '-122.4194',
        stopType: 'delivery',
        appointment: {
          channel: 'shipperguide',
          mode: 'appt',
          loadingType: 'live',
          type: 'requested',
          status: 'pending',
          suggestedDate: { type: 'between', start: '2024-03-26', end: '2024-03-27' },
          suggestedTime: { type: 'after', start: '0800', end: '0800' },
        },
      },
    ],
    mileage: 382,
    flatRate: 1200.0,
    pricePerMile: 3.14,
    expirationDate: new Date(Date.now() + 2 * 60 * 60 * 1000),
    mode: 'FTL',
    equipmentType: 'DRV',
    equipmentTypeLabel: 'Dry Van',
    shipperGuideId: 'SGB5LTM0KGBB8',
    status: 'available',
    rateType: 'Spot',
    createdAt: new Date('2024-03-20T11:00:00Z'),
    shareDetails: true,
    powerOnly: false,
    attachments: [],
    items: [],
    rate: {
      uuid: '61040fd0-ed1d-4244-9e00-e5a6b3712545',
    },
  },
  {
    id: '9329f290-26c1-4a86-aae7-a41ecf1c53a9',
    shipper: {
      companyName: 'Carrier Marketplace Shipper',
      email: 'info@globallogistics.com',
      logoUrl:
        'https://rfpguide-staging.s3.amazonaws.com/media/logos/1043/croppedimage_07b75c54.jpeg',
    },
    carrier: {
      id: 5233,
      name: 'Robin Moody 0',
      email: 'fixture-email-123@carrier.com',
      entityType: 'carrier',
    },
    stops: [
      {
        city: 'Dallas',
        state: 'TX',
        zipCode: '75201',
        address: '789 Commerce Street',
        date: '2024-03-23',
        country: 'USA',
        stopIndex: 0,
        latitude: '32.7767',
        longitude: '-96.7970',
        stopType: 'pickup',
        appointment: {
          channel: 'shipperguide',
          mode: 'appt',
          loadingType: 'live',
          type: 'requested',
          status: 'confirmed',
          scheduledDate: { type: 'at', start: '2024-03-23', end: '2024-03-23' },
          scheduledTime: { type: 'at', start: '1600', end: '1600' },
        },
      },
      {
        city: 'Houston',
        state: 'TX',
        zipCode: '77001',
        address: '321 Business Blvd',
        date: '2024-03-24',
        country: 'USA',
        stopIndex: 1,
        latitude: '29.7604',
        longitude: '-95.3698',
        stopType: 'delivery',
        appointment: {
          channel: 'shipperguide',
          mode: 'appt',
          loadingType: 'live',
          type: 'requested',
          status: 'confirmed',
          scheduledDate: { type: 'at', start: '2024-03-24', end: '2024-03-24' },
          scheduledTime: { type: 'at', start: '0900', end: '0900' },
        },
      },
    ],
    mileage: 239,
    flatRate: 850.5,
    pricePerMile: 3.56,
    expirationDate: new Date(Date.now() + 1 * 60 * 60 * 1000),
    mode: 'DRAY',
    equipmentType: 'DRB',
    equipmentTypeLabel: 'Dry Box',
    shipperGuideId: 'SGB7QRKGIEKYS',
    status: 'available',
    rateType: 'Spot',
    createdAt: new Date('2024-03-20T09:00:00Z'),
    shareDetails: true,
    powerOnly: false,
    attachments: [],
    items: [],
    rate: {
      uuid: 'c0d17eec-35ba-4a36-8704-5c4263b34e8f',
    },
  },
]
